import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "flex shrink-0 items-center pr-2"
};
const _hoisted_2 = ["disabled"];
const _hoisted_3 = {
    key: 1,
    class: "flex shrink-0 items-center pl-2"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        "data-slot": "input",
        class: _normalizeClass($setup.cn($setup.inputWrapperVariants({ focused: $props.focused, hasError: $props.hasError, disabled: $props.disabled }), $setup.props.class))
    }, [
        (_ctx.$slots.prepend)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _renderSlot(_ctx.$slots, "prepend")
            ]))
            : _createCommentVNode("v-if", true),
        _createElementVNode("input", _mergeProps($setup.attrs, {
            disabled: $props.disabled,
            class: $setup.cn('min-w-0 flex-1 bg-transparent py-1 text-sm outline-none', 'placeholder:text-muted-foreground', 'not-placeholder-shown:text-en-blue-500', 'disabled:cursor-not-allowed', 'read-only:cursor-default', '[type=number]:appearance-auto')
        }), null, 16 /* FULL_PROPS */, _hoisted_2),
        (_ctx.$slots.append)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _renderSlot(_ctx.$slots, "append")
            ]))
            : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */));
}
